import { Component, Input, SimpleChanges, OnInit } from '@angular/core';
import { SettingsService } from '../settings.service';
import { LoginService } from '../login.service';

@Component({
    selector: 'app-price-list',
    templateUrl: './price-list.component.html',
    styleUrls: ['./price-list.component.scss'],
    standalone: false
})
export class PriceListComponent implements OnInit {
  @Input() selectedUserId: number | null = null;
  newExam = { examPrice: '', examPriceTwins: '', AutoIndex: null,UID:this.ls.doctor,expatriatePrice:'',otherPrice:'',examId:null};
  exams = [];
  examsSettings: any[] = [];
  error=false
  ApptsByRoom=false
  constructor(public settingsService:SettingsService,public ls:LoginService) { }

  async ngOnInit() {
    this.ApptsByRoom=this.ls.premissions?.ApptsByRoom
    this.examsSettings = await this.getExamNames();
  }

  
  async ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedUserId) {
      if(this.ApptsByRoom){
        this.exams=await this.settingsService.getExamsPrice(null,'Private')
      }
      else{
        this.exams=await this.settingsService.getExamsPrice(this.ls.doctor,'Private')
      }
    }
  }

  
  getExamTypes(){
    return this.settingsService.getDefault()
  }
  async getExamNames() {
    const exams=await this.settingsService.getExams()
    if(!Array.isArray(exams)) return []
    return exams.filter((exam)=>!exam.custom)
  }

  async saveNewExam() {
    if (!this.newExam.examId ) {
      alert('Exam name is required.');
      return;
    }
    try {
    const result =await this.settingsService.saveNewExamPrice({...this.newExam,UID:this.ls.doctor},'Private')
    if (result['status']=='ok') {
      this.error=false;
      this.newExam = { examPrice: '',  examPriceTwins: '', AutoIndex: null,UID:this.ls.doctor,expatriatePrice:'',otherPrice:'',examId:null};
      this.exams=await this.settingsService.getExamsPrice(this.ls.doctor,'Private')
      

    }
  } catch (error) {
    console.error('Error during the save New Exam', error);
    this.error=true
  }
  }

  async deletePrice(price){
    try {
      const result = await this.settingsService.deletePrice(price);
      if (result['status']=='ok') {
        this.error=false;
        this.exams=await this.settingsService.getExamsPrice(this.ls.doctor,'Private')
      }
    } catch (error) {
      console.error('Error during the update exam price for private:', error);
      this.error=true
    }
  }

  
  editExam(exam) {
    exam.isEditing = true;
  }


  
  async saveChanges(exam) {
    try {
      const result = await this.settingsService.updateExamPrice(exam);
      if (result['status']=='ok') {
        this.error=false;
        exam.isEditing = false;

      }
    } catch (error) {
      console.error('Error during the update exam price details:', error);
      this.error=true
    }
  }
}
